import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { TextLoca } from "../generic/text/TextLoca";
export var PlayerProfileNoCoopInfo = React.memo(function (_a) {
    return (React.createElement("div", { className: "flex flex--guts" },
        React.createElement("div", { className: IdStyles.PlayerProfileCoopBackground + " flex flex--guts" },
            React.createElement("div", { className: "big-coop-picture big-coop-picture__locked" })),
        React.createElement("div", { className: "player-profile__no-coop-text" },
            React.createElement(TextLoca, { className: IdStyles.TextBoldPrimary, id: IdLoca.noCooperative }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/PlayerProfileNoCoopInfo.tsx
// module id = 2878
// module chunks = 3